import BoldText from '@/components/BoldText';
import CustomBadge from '@/components/CustomBadge';
import { config } from '@/config';
import { SHOPS_CUSTOM_CSS } from '@/constants/shop-custom';
import userPlans from '@/hooks/userPlans';
import { handleChangePreview, previewSelector } from '@/redux/slice/preview.slice';
import { Editor } from '@monaco-editor/react';
import { Card, Divider } from '@shopify/polaris';
import { CSSProperties } from 'react';
import { useDispatch, useSelector } from 'react-redux';

function CustomCSS() {
  const dispatch = useDispatch();
  const previewDetail = useSelector(previewSelector);
  const { isUserFreeOrBasic } = userPlans();
  const isDisabledCustomCss = isUserFreeOrBasic && !SHOPS_CUSTOM_CSS?.includes(config.shop);

  const handleChange = (value: string | undefined) => {
    if (isDisabledCustomCss) {
      return;
    }

    dispatch(handleChangePreview({ customCss: value }));
  };

  const styleEditor: CSSProperties = {
    pointerEvents: isDisabledCustomCss ? 'none' : 'auto',
    opacity: isDisabledCustomCss ? 0.5 : 1,
  };

  return (
    <Card>
      <BoldText>CSS {isDisabledCustomCss && <CustomBadge />}</BoldText>
      <div className="mt-8 mb-8">
        <Divider />
      </div>

      <div style={styleEditor}>
        <Editor
          height="400px"
          onChange={(value) => handleChange(value)}
          defaultLanguage="css"
          theme="vs-dark"
          defaultValue={previewDetail.customCss || ''}
          options={{
            automaticLayout: true,
          }}
          value={previewDetail.customCss || ''}
        />
      </div>
    </Card>
  );
}

export default CustomCSS;
